<template>
	<div>
		<!-- Dialog -->
		<v-dialog v-model="showDialog" max-width="550" dir="rtl">
			<v-card class="rounded-lg">
				<v-card-title class="d-flex flex-column justify-center align-center" dir= "rtl">
					<div>
						<v-img src="@/assets/photoDialog.png" width="280"  />
					</div>
					<span>
						تتبع الحافلات
					</span>
				</v-card-title>

				<v-card-text class="pb-2 text-center d-flex flex-column justify-center align-center" dir="rtl">
					<span style="font-weight: 600">
						لتفعيل ميزة تتبع الحافلات تواصل معنا
					</span>
					<span style="font-weight: 600">00963-993327101</span>
					<a href="https://edunixsystem.com/" target="_blank" style="text-decoration: none; color: inherit; " > Edunix system </a>
				</v-card-text>
				<v-card-actions>
					<!-- <v-spacer></v-spacer> -->
					<v-btn color="primary" text @click="showDialog = false">
						موافق
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-row class="d-flex justify-space-between align-center">
			<v-col cols="12" >
				<!-- tabs -->
				<v-tabs v-model="tab" show-arrows height="40" centered grow @change="(() => {
						if (tab === 2 && !transportUrl) {
							tab = 1
							showDialog = true
						}
					})">
					<v-tab
						class="text-capitalize "
						:class="{'border-style': !canUseEdunixManager}"
					>
						<div v-if="!canUseEdunixManager" class="premier-icon d-flex align-center flex-column">
							<v-icon class="" size="18" color="#fb5d33">mdi-crown</v-icon>
							<span class="text-style pb-1">Premium</span>
						</div>
						Manager
					</v-tab>
					<v-tab
						class="text-capitalize "
						:class="{'border-style': !canUseControlPanel}"
					>
						<div v-if="!canUseControlPanel" class="premier-icon d-flex align-center flex-column">
							<v-icon class="" size="18" color="#fb5d33">mdi-crown</v-icon>
							<span class="text-style">Premium</span>
						</div>
						Message Cp
					</v-tab>

					<v-tab
						class="text-capitalize premier-tab"
						:class="{'border-style': !transportUrl}"
					>
						<div v-if="!transportUrl" class="premier-icon d-flex align-center flex-column">
							<v-icon class="" size="18" color="#fb5d33">mdi-crown</v-icon>
							<span class="text-style">Premium</span>
						</div>
						Transport
					</v-tab>

					<v-tabs-slider color="primary"></v-tabs-slider>
				</v-tabs>
				<v-divider class="mb-2"/>
				<v-tabs-items v-model="tab" >
					<v-tab-item v-if="canUseEdunixManager">
						<iframe
							:src="managerUrl"
							style="width: 100%; height: 100% border: none;"
							title="Manager"
							:style="{ height: ($vuetify.breakpoint.height - 66 ) + 'px' }"
						></iframe>
					</v-tab-item>
					<v-tab-item  v-if="canUseControlPanel">
						<iframe
							:src="cpUrl"
							style="width: 100%; border: none;"
							title="Manager"
							:style="{ height: ($vuetify.breakpoint.height - 66 ) + 'px' }"
						></iframe>
					</v-tab-item>
					<v-tab-item v-if="transportUrl">
						<iframe
							:src="transportUrl"
							style="width: 100%; border: none;"
							title="Manager"
							:style="{ height: ($vuetify.breakpoint.height - 66 ) + 'px' }"
						></iframe>
					</v-tab-item>
				</v-tabs-items>
			</v-col>
		</v-row>

		<!-- child page -->
		<loader v-if="loading"/>
	</div>
</template>
<script>
import { mapState } from 'vuex'
export default {
	// ?password=${JSON.parse(localStorage.getItem('auth').password)}
	data () {
		return {
			tab: 0,
			loading: false,
			// managerUrl: `https://manager.mirror.edunixsystem.com/?password=${JSON.parse(localStorage.getItem('auth').password)}&userName=admin&centerId=0`,
			// cpUrl: ``,
			// transportUrl: ,
			showDialog: false
		}
	},
	//
	computed: {
		...mapState({
			canUseControlPanel: state => state.auth.user.canUseControlPanel,
			canUseEdunixManager: state => state.auth.user.canUseEdunixManager,
			cauUseEdunixTransport: state => state.auth.user.cauUseEdunixTransport
		}),

		transportUrl () {
			return `http://transport.motherland.edunixsystem.com/?password=${JSON.parse(localStorage.getItem('auth')).password}&userName=${JSON.parse(localStorage.getItem('auth')).userName}&centerId=${JSON.parse(localStorage.getItem('auth')).centerId}`
		},

		cpUrl () {
			return `https://cp.motherland.edunixsystem.com/?password=${JSON.parse(localStorage.getItem('auth')).password}&userName=${JSON.parse(localStorage.getItem('auth')).userName}&centerId=${JSON.parse(localStorage.getItem('auth')).centerId}`
		},

		managerUrl () {
			return `https://manager.motherland.edunixsystem.com/?password=${JSON.parse(localStorage.getItem('auth')).password}&userName=${JSON.parse(localStorage.getItem('auth')).userName}&centerId=${JSON.parse(localStorage.getItem('auth')).centerId}`
		}
	},

	methods: {
		handleTabChange (newTab) {
			// إذا كان التبويب الثاني (Cp) وقيمة showCp هي false
			if (newTab === 1 && !this.canUseControlPanel) {
				this.showDialog = true // إظهار الـ dialog
				this.tab = this.previousTab // العودة إلى التبويب السابق
				return
			} else if (newTab === 0 && !this.canUseEdunixManager) {
				this.showDialog = true // إظهار الـ dialog
				// this.tab = this.previousTab // العودة إلى التبويب السابق
			} else if (newTab === 2 && this.cauUseEdunixTransport === false) {
				this.showDialog = true // إظهار الـ dialog
				this.tab = this.previousTab
			}
			this.previousTab = newTab
		}
	}
}
</script>

<style scoped>
.border-style {
	border: 2px solid #fb5d33;
	border-radius: 10px ;
}

.premier-tab {
	position: relative;
	overflow: visible !important;
}

.premier-icon {
	position: absolute;
	top: 0px;
	right: 2%;
	color: gold;
}

.text-style {
	color: #fb5d33;
	font-size: 10px;
}
</style>
